const isSsoPassword = (password?: string) => Boolean(password?.startsWith('SSO-'));

type NormalizeEditUserPayloadOptions = {
  isInitiallySso: boolean;
  createSsoPassword: () => string;
};

export const normalizeEditUserPayload = (
  data: Record<string, any>,
  options: NormalizeEditUserPayloadOptions,
) => {
  const transformedData = {...data};
  const hasSsoMarkerPassword = isSsoPassword(transformedData.password);
  const isSsoEnabled = Boolean(transformedData.__isSso) || hasSsoMarkerPassword;

  delete transformedData.__isSso;

  if (isSsoEnabled) {
    if (!hasSsoMarkerPassword) {
      transformedData.password = options.createSsoPassword();
    }
    return transformedData;
  }

  const hasEmptyPassword =
    typeof transformedData.password === 'string' && transformedData.password.trim() === '';

  if (hasEmptyPassword && !options.isInitiallySso) {
    delete transformedData.password;
  }

  return transformedData;
};